module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/full-width-5d693d94c8a4e02575bb88f86dd7a935.png";